function isPrescriptionGlassesTypeDetails(typeDetails) {
    return (typeDetails === null || typeDetails === void 0 ? void 0 : typeDetails.__typename) === 'BundlePrescriptionGlassesTypeDetails';
}
function isNonPrescriptionBundleTypeDetails(typeDetails) {
    return (typeDetails === null || typeDetails === void 0 ? void 0 : typeDetails.__typename) === 'BundleNonPrescriptionBundleTypeDetails';
}

export { isNonPrescriptionBundleTypeDetails, isPrescriptionGlassesTypeDetails };
//# sourceMappingURL=cart-line-item-product-type-guards.js.map
